<div *ngIf="product" class="d-flex flex-row flex-wrap">
  <div *ngIf="this.product?.attributes && this.product?.attributes.length > 0" class="flex-100 px-1 product-detail-controls">
    <div class="d-flex flex-row flex-wrap attribute-group justify-content-start align-items-start">
      <div *ngFor="let attributeForm of attributeForms; let i = index" class="attribute flex-100">
        <form [formGroup]="attributeForms[i]">
          <ng-container *ngIf="attributeForm.controls.controlType.value === 'DropdownList'">
            <mat-card-title class="attribute-title">{{attributeForm.controls.textPrompt.value}}</mat-card-title>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{attributeForm.controls.textPrompt.value}}</mat-label>
              <mat-select placeholder="{{attributeForm.controls.textPrompt.value}}" formControlName="selectedOption" required (selectionChange)="attChangeDropDown($event, attributeForm)">
                <mat-option *ngFor="let option of attributeForm.controls.options.value" [value]="option">
                  {{option?.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <ng-container *ngIf="attributeForm.controls.controlType.value === 'RadioList'">
            <mat-card-title *ngIf="attributeForm?.controls?.options?.value?.length !== 1" class="attribute-title">{{attributeForm.controls.textPrompt.value}}</mat-card-title>
            <mat-radio-group class="d-flex flex-column" required>
              <mat-radio-button *ngFor="let option of attributeForm.controls.options.value" [checked]="option.selected" color="primary" class="attribute-select" [value]="option" (change)="attChangeRadio($event, attributeForm)">
                <span>{{option?.name}}</span>
              </mat-radio-button>
            </mat-radio-group>
          </ng-container>
          <ng-container *ngIf="attributeForm.controls.controlType.value === 'Multi' && attributeForm.controls.maximum?.value < 5">
            <div class="multi-select flex-100 mt-1 pb-2">
              <div class="multi-title pl-2">
                <span>{{attributeForm.controls.textPrompt.value}} Choose {{attributeForm.controls.maximum?.value}} ({{attributeForm.controls.noSelected.value}} Selected)</span>
                <button mat-mini-fab *ngIf="attributeForm.controls.noSelected?.value === attributeForm.controls.maximum?.value" color="accent">
                  <mat-icon color="primary">done</mat-icon>
                </button>
              </div>
              <div class="d-flex flex-row flex-wrap py-1" *ngFor="let option of attributeForm.controls.options.value">
                <div class="flex-50 flex-fill pl-2">
                  <span [class]="option.noSelected === 0 ? 'multi-name': 'multi-name-active'">{{option?.name}}</span>
                </div>
                <div class="flex-50 flex-fill">
                  <div class="d-flex flex-row flex-wrap">
                    <div *ngFor="let in of counter(attributeForm.controls.maximum.value + 1) ;let i = index" class="flex-{{100/(attributeForm.controls.maximum.value + 1)}} flex-fill">
                      <button mat-mini-fab (click)="multiOptionClick(attributeForm, option.optionId, i)" [color]="option.noSelected == i ? 'primary' : 'accent'" [class]="attributeForm.controls.maximum.value > 2 ? 'small-mini-fab' : ''">{{i}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="attributeForm.controls.controlType.value === 'Multi' && attributeForm.controls.maximum?.value >=5">
            <div class="multi-select flex-100 mt-1 pb-2">
              <div class="multi-title pl-2">
                <span>{{attributeForm.controls.textPrompt.value}} Choose {{attributeForm.controls.maximum?.value}} ({{attributeForm.controls.noSelected.value}} Selected)</span>
                <button mat-mini-fab *ngIf="attributeForm.controls.noSelected?.value === attributeForm.controls.maximum?.value" color="accent">
                  <mat-icon color="primary">done</mat-icon>
                </button>
              </div>
              <div class="d-flex flex-row flex-wrap py-1" *ngFor="let option of attributeForm.controls.options.value">
                <div class="flex-7 flex-fill pl-2">
                  <span [class]="option.noSelected === 0 ? 'multi-number': 'multi-number-active'">{{option?.noSelected}}</span>
                  <span [class]="option.noSelected === 0 ? 'multi-number': 'multi-number-active'">x</span>
                </div>
                <div class="flex-43 flex-fill pl-2">
                  <span [class]="option.noSelected === 0 ? 'multi-name': 'multi-name-active'">{{option?.name}}</span>
                </div>
                <div class="flex-50 flex-fill">
                  <div class="d-flex flex-row flex-wrap">
                    <div class="flex-25 flex-md-20 flex-fill">
                      <button mat-mini-fab (click)="multiOptionClick(attributeForm, option.optionId, 0)" color="accent">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                    <div class="flex-25 flex-md-20 flex-fill">
                      <button mat-mini-fab (click)="multiOptionClick(attributeForm, option.optionId, option.noSelected + 1)" color="primary">+1</button>
                    </div>
                    <div class="d-none d-md-flex flex-20 flex-fill">
                      <button mat-mini-fab (click)="multiOptionClick(attributeForm, option.optionId, option.noSelected + 2)" color="primary">+2</button>
                    </div>
                    <div class="flex-25 flex-md-20 flex-fill">
                      <button mat-mini-fab (click)="multiOptionClick(attributeForm, option.optionId, option.noSelected + 5)" color="primary">+5</button>
                    </div>
                    <div class="flex-25 flex-md-20 flex-fill">
                      <button mat-mini-fab (click)="multiOptionClick(attributeForm, option.optionId, option.noSelected + 10)" color="primary">+10</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="attributeForm.controls.controlType.value === 'Checkboxes'">
            <mat-card-title class="attribute-title">{{attributeForm.controls.textPrompt.value}}</mat-card-title>
            <mat-list-item class="d-flex flex-column checkbox-group justify-content-center">
              <mat-checkbox *ngFor="let option of attributeForm.controls.options.value;" [checked]="option.selected" [value]="option" color="primary" class="attribute-select" (change)="attChangeCheckboxes($event, option, attributeForm)">
                <span>{{option?.name}}</span>
              </mat-checkbox>
            </mat-list-item>
          </ng-container>
          <ng-container *ngIf="attributeForm.controls.controlType.value === 'TextBox'">
            <mat-card-title class="attribute-title">{{attributeForm.controls.textPrompt.value}}</mat-card-title>
            <!-- TODO -->
          </ng-container>
          <ng-container *ngIf="attributeForm.controls.controlType.value === 'MultilineTextbox'">
            <mat-card-title class="attribute-title">{{attributeForm.controls.textPrompt.value}}</mat-card-title>
            <!-- TODO -->
          </ng-container>
          <ng-container *ngIf="attributeForm.controls.controlType.value === 'Datepicker'">
            <mat-card-title class="attribute-title">{{attributeForm.controls.textPrompt.value}}</mat-card-title>
            <!-- TODO -->
          </ng-container>
          <ng-container *ngIf="attributeForm.controls.controlType.value === 'FileUpload'">
            <mat-card-title class="attribute-title">{{attributeForm.controls.textPrompt.value}}</mat-card-title>
            <!-- TODO -->
          </ng-container>
          <ng-container *ngIf="attributeForm.controls.controlType.value === 'ColorSquares'">
            <mat-card-title class="attribute-title">{{attributeForm.controls.textPrompt.value}}</mat-card-title>
            <!-- TODO -->
          </ng-container>
          <ng-container *ngIf="attributeForm.controls.controlType.value === 'ImageSquares'">
            <mat-card-title class="attribute-title">{{attributeForm.controls.textPrompt.value}}</mat-card-title>
            <!-- TODO -->
          </ng-container>
          <ng-container *ngIf="attributeForm.controls.controlType.value === 'ReadonlyCheckboxes'">
            <mat-card-title class="attribute-title">{{attributeForm.controls.textPrompt.value}}</mat-card-title>
            <mat-list-item class="d-flex flex-column justify-content-center">
              <mat-checkbox *ngFor="let option of attributeForm.controls.options.value;" [formControlName]="'selectedOptions'" [checked]="true" color="primary" class="attribute-select" [value]="option">
                <span>{{option?.name}}</span>
              </mat-checkbox>
            </mat-list-item>
          </ng-container>
        </form>
      </div>
    </div>
  </div>
  <div class="flex-100 d-flex flex-row flex-wrap product-detail-controls" *ngIf="product?.stockQuantity > 0">
    <div class="flex-100 d-flex flex-row flex-wrap justify-content-start align-items-start tier-wrapper" *ngIf="product?.tierPrices && product?.tierPrices.length > 0">
      <div class="flex-100 tier-intro">Buy More &amp;
        <span class="tier-save">save</span>
      </div>
      <div class="flex-100 d-flex flex-row flex-wrap">
        <div *ngFor="let tier of product?.tierPrices" class="flex-{{tierFlex()}} tier-control">
          <div class="d-flex flex-column justify-content-start align-items-center">
            <div class="text-center icons">
              <button mat-raised-button color="accent" class="add-to-cart" matTooltip="Add to cart" (click)="addToCart(tier.quantity)">
                <mat-icon>add_shopping_cart</mat-icon><span>Add {{tier.quantity}}</span>
              </button>
            </div>
            <div class="text-center tier-price">
              {{tier.price | currency}} each</div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-100 mt-2">
      <div *ngIf="this.product?.attributes && this.product?.attributes.length > 0" class="d-flex flex-row flex-wrap justify-content-start align-items-start">
        <form [formGroup]="cartForm">
          <mat-form-field *ngIf="product?.stockQuantity > 0" appearance="outline" class="quantity">
            <mat-label>Qty</mat-label>
            <input matInput type="number" placeholder="Qty" formControlName="quantity">
          </mat-form-field>
        </form>
        <div *ngIf="product?.stockQuantity > 0" class="px-1">
          <button mat-raised-button color="primary" class="add-to-cart" matTooltip="Add to cart" (click)="addToCart()">
            <mat-icon>add_shopping_cart</mat-icon><span>Add to Cart</span>
          </button>
        </div>
        <div *ngIf="product?.stockQuantity < 1" class="px-1">
          <button mat-raised-button color="accent" class="out-of-stock" matTooltip="Notify Feature coming soon" name="Notify" (click)="backSoon()">
            <mat-icon>remove_shopping_cart</mat-icon><span>Back Soon ...</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="product?.allowBackInStockSubscriptions && product?.stockQuantity < 1 && !informed" class="flex-100 flex-fill px-1">
    <div class="flex-100" *ngIf="loggedIn">
      <div class="d-flex flex-row flex-wrap">
        <div class="flex-100 flex-fill">
          <h3 class="mt-2 backinstock-title justify-content-start align-items-center">Hey {{this.customer.firstName}}, want to know when '{{product?.name}}' has arrived back in stock?</h3>
        </div>
        <div class="flex-100 flex-fill">
          <button mat-raised-button color="primary" class="add-to-cart" matTooltip="Inform Me" (click)="backInStock()">
            <mat-icon>alarm</mat-icon>&nbsp;Let me Know
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="!loggedIn">
      <h3 *ngIf="customer && customer?.firstName" class="justify-content-start align-items-center mt-2 backinstock-title mx-1">Hey {{customer?.firstName}}!<br /></h3>
      <h3 class="backinstock-title">Want to know when the&nbsp;
        <span class="product-name mx-1">{{product?.name}}</span>&nbsp;has more stock?
      </h3>
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>alarm</mat-icon><span class="backinstock-acc">Sign up or Log in to be kept in the loop!</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <button mat-raised-button (click)="stockRegister=!stockRegister" color="primary">{{stockRegister?'Already Registered? Tap here to login':'Register a new account'}}</button>
          <div *ngIf="stockRegister">
            <form [formGroup]="registerForm">
              <mat-form-field appearance="outline" class="w-100 mt-2">
                <mat-label>First Name</mat-label>
                <input matInput placeholder="Full Name" formControlName="firstName" required>
                <mat-error *ngIf="registerForm.controls.firstName.errors?.required">Full Name is required</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100 mt-2">
                <mat-label>Last Name</mat-label>
                <input matInput placeholder="Last Name" formControlName="lastName" required>
                <mat-error *ngIf="registerForm.controls.lastName.errors?.required">Full Name is required</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100 mt-1">
                <mat-label>Email</mat-label>
                <input matInput placeholder="Email" formControlName="email" type="email" required>
                <mat-error *ngIf="registerForm.controls.email.errors">Invalid email address</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100 mt-1">
                <mat-label>Password</mat-label>
                <input matInput placeholder="Password" formControlName="password" type="password" minLength="6" required autocomplete="off">
                <mat-error *ngIf="registerForm.controls.password.errors">Password is a minimum of 6 characters</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100 mt-1">
                <mat-label>Confirm Password</mat-label>
                <input matInput placeholder="Confirm Password" formControlName="confirmPassword" type="password" required autocomplete="off">
                <mat-error *ngIf="registerForm.controls.confirmPassword.errors">Passwords do not match</mat-error>
              </mat-form-field>
              <mat-checkbox formControlName="newsLetter" color="primary">Sign me up for news and offers</mat-checkbox>
              <div class="text-center mt-2">
                <button mat-raised-button (click)="onRegisterFormSubmit()" color="primary">
                  <mat-icon>alarm</mat-icon>&nbsp;Let me Know
                </button>
              </div>
            </form>
          </div>
          <div *ngIf="!stockRegister">
            <form [formGroup]="loginForm">
              <mat-form-field appearance="outline" class="w-100 mt-2">
                <mat-label>Email</mat-label>
                <input matInput placeholder="Email" formControlName="email" required>
                <mat-error *ngIf="loginForm.controls.email.errors">Invalid email address</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100 mt-1" [hidden]="hidePassword">
                <mat-label>Password</mat-label>
                <input matInput placeholder="Password" formControlName="password" type="password" required autocomplete="off">
                <mat-error *ngIf="loginForm.controls.password.errors">Password is a minimum of 6 characters</mat-error>
              </mat-form-field>
              <div class="text-center mt-2" [hidden]="hidePassword">
                <button mat-raised-button (click)="onLoginFormSubmit()" color="primary">
                  <mat-icon>alarm</mat-icon>&nbsp;Let me Know
                </button>
              </div>
              <div class="get-password">
                <mat-expansion-panel (opened)="hidePassword=true; resetHeader='Back to Logon';" (closed)="hidePassword=false;resetHeader='Forgot password? Get a new one'">
                  <mat-expansion-panel-header>
                    <div style=" width:100%; padding:7px; text-transform: uppercase;text-align: center;">
                      <a mat-button>{{resetHeader}}</a>
                    </div>
                  </mat-expansion-panel-header>
                  <span>Fill in your email above and click the request password button. We will send you instructions.</span>
                  <br /><br />
                  <button mat-raised-button color="primary" (click)="resetPassword()">Request New Password</button>
                </mat-expansion-panel>
              </div>
            </form>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div *ngIf="product?.allowBackInStockSubscriptions && product?.stockQuantity < 1 && informed" class="flex-100 flex-fill mt-1 mb-1 px-1">
    Thank you, we will let you know as soon as the stock arrives.
  </div>
  <div class="d-flex flex-row flex-wrap" *ngIf="!product">
    <div class="flex-100">
      <span>Loading Product Details</span>
    </div>
    <div class="flex-100">
      <img [src]="settings?.holdingImage?.medium" alt="Product Waiting" />
    </div>
  </div>
